define([
	"dojo/_base/declare",
	"csi/constants",
	"csi/table/matrix/Path",
	"csi/xml",
	"csi/xml/Search",
	"csi/html",
	"csi/utility/pathUtility",
	"lodash",
	"./_SharedSectionMatrixMixin",
], function(declare, {FMT_ATTR_LIST}, Path, xml, Search, html, {pathCreate}, {forEach}, base) {

	/** @property {Object} _valueMap - Maps value types to the optional attributes on the SpecificationDatasheetItem */
	const _valueMap = {
		[xml.ATTR_REF]: "ValueLookupItem",
		[xml.ATTR_REFLIST]: "ValueLookupItemList",
		[xml.ATTR_BOOLEAN]: "ValueBoolean",
		[xml.ATTR_DOUBLE]: "ValueDouble",
		[xml.ATTR_INTEGER]: "ValueInt",
		[xml.ATTR_STRING]: "ValueString",
	};

	return declare([Path, base], {
		columnPath: null,
		columnSortAttr: "UDCMatrixSortCode",

		/** {C8Node[]} specItems - spec item nodes */
		specItems: null,

		/**
		 * @override
		 * do the query to get the required nodes to process the column nodes
		 */
		addDeferred(ctx, h, dfds) {
			const currentNode = ctx.getNode();
			const search = new Search()
				.byType("SpecificationItemDefinition")
				.addParameter(FMT_ATTR_LIST, "SpecificationItemDefinition:Node Name;SysID;Code;ValueAttributeDefinition", true);

			let path = pathCreate("SharedSpecSections", "SectionItems", "Definition");

			if (currentNode.$Type === "ProductHierarchyDetails") {
				path = `Parent:ProductHierarchyDetails/${path}`;
			}

			search.setLimitPath(currentNode.$URL, path);
			search.addDependencyPaths([pathCreate("ValueAttributeDefinition")]);
			search.getQuery().SortByAttr(this.columnSortAttr);

			dfds.push(search.execute().then((response) => {
				ctx.cache.cacheResponse(response);
				this.specItems = response.getResultNodes();
			}));
		},

		/**
		 * @override
		 * add dependency path so that the filter on the spec item which references a lookup item would apply
		 */
		addDependencyPaths(h, paths) {
			this.inherited(arguments);

			paths.push(pathCreate("SharedSpecSections", "SectionItems"));
		},

		/**
		 * @override
		 * Just load the necessary attributes to avoid the potential performance issues
		 */
		addRootRequestParameters(request) {
			this.inherited(arguments);

			request.addParameter(FMT_ATTR_LIST, "SpecificationSection:SectionItems", true);
			request.addParameter(FMT_ATTR_LIST, "SpecificationSectionItem:ApplicableValueLookupItems;Definition;VisibleInAllStylesView", true);
		},

		/**
		 * @override
		 * Returns the specs of the column nodes where each column is a SpecificationItemDefinition with differing value attributes.
		 */
		getColumnSpecs(ctx, h) {
			const {cache, view} = ctx;
			const {relRoot} = view;
			const targetType = relRoot.getTargetType();
			const columnNodes = view.skipColumnMatrices ? null : (this.specItems || this._getColumnNodes(ctx, h));
			const specs = [];

			if (!columnNodes.length) {
				return specs;
			}

			// Iterate over SpecificationSectionItems and map key of Definition to value of VisibleInAllStylesView if VisibleInAllStylesView is true
			const definitionToVisibleMap = {};
			forEach(cache._data, (node) => {
				if (node.$Type === "SpecificationSectionItem" && node.VisibleInAllStylesView) {
					definitionToVisibleMap[node.Definition] = node.VisibleInAllStylesView;
				}
			});

			const {m_path, m_id} = h;
			const defnUrlList = [];

			columnNodes.forEach((defn) => {
				const defnUrl = defn.$URL;

				if (defnUrlList.includes(defnUrl) || !definitionToVisibleMap[defnUrl]) {
					return;
				}

				defnUrlList.push(defnUrl);
				const vad = cache.get(defn.ValueAttributeDefinition);
				const format = vad.Format;
				const type = vad.ValueType;
				const id = _valueMap[type];

				// Create Spec
				const spec = this.createSpec(ctx, targetType, m_path, m_id, defn.SysID, id, format, defnUrl, defn.$Name, html.CSS_NOT_APPLICABLE);

				specs.push(spec);
			});

			if (specs.length) {
				specs[0].css += " csi-table-matrix-column-first";
				specs[specs.length - 1].css += " csi-table-matrix-column-last";
			}

			return specs;
		},
	});
});